import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CNConsultation } from '../models/cnconsultation';
import { CNPatient } from '../models/cnpatient';
import { SNItemFactory } from '../models/snitemfactory';
import { BecareService } from './becare.service';
import { PatientService } from './patient.service';

@Injectable({
  providedIn: 'root'
})
export class ConsultationService {

  constructor(private becare: BecareService, private patientSrv: PatientService) { }

  save(consultation: CNConsultation, patient?: CNPatient): Observable<CNConsultation> {
    // tslint:disable-next-line:max-line-length
    return new Observable(observer => {
      let patientid = this.patientSrv.patient.id;
      if (patient) {
        patientid = patient.id;
      }
      this.becare.call('/fr/patient/' + patientid + '/consultation', [], consultation.toObj(), 'post').subscribe(result => {
        if (result.success) {
          const factory = new SNItemFactory();
          observer.next(factory.itemFromJson(result.consultation));
        } else {
          observer.error('failed to store consultation');
        }
      });
    });
  }
}
